<template>
    <div v-bind:class="app_container_class" id="app-container" ref="appcontainer">
        <div class="container-fluid" v-if="this.$root.cart_is_loaded && this.$root.product_is_loaded">
            <div class="col-12 p-4" id="catalog-component-container">
                <form id="ticketing_form" ref="ticketing_form" method="post">
                    <catalog-component/>
                </form>
            </div>
        </div>
    </div>
    <transition name="content-fade">
        <footer-component
            :section="section" />
    </transition>

</template>

<script>
import {defineComponent} from "vue";
import CartComponent from "../cart/Cart";
import CatalogComponent from "../catalog/Catalog";
import FooterComponent from "../footer/Footer";

export default defineComponent({
    emits: [ 'send' ],

    components: {
        'cart-component': CartComponent,
        'catalog-component': CatalogComponent,
        'footer-component': FooterComponent,
    },

    data() {
        return {
            app_container_class: 'd-block p-0 m-0 bg-phoenix-no-logo padding-bottom-footer',
            cart_items: null,
        }
    },

    methods: {
        receive(sent_data)
        {
            if(sent_data === 'switch_locale')
            {
                this.$forceUpdate();
            }
        },
    },

    created() {
        this.$root.show_btn_confirmer = true;
        this.$root.global_cancel_btn_disabled = false;
        this.$root.current_loading_message = this.trans.get('kiosk.loading-ticketing');
        this.$root.current_event_is_loaded.push('Catalog');
    },

    mounted() {
    },

    name: "Store",

    props: {
        section: String,
        locale: String,
    },
})
</script>

